// src/api/stats.service.js
import API from './axiosConfig';

/**
 * Get booking statistics and history with filters
 * @param {Object} params - Query parameters
 * @param {string} params.from_date - Start date (YYYY-MM-DD)
 * @param {string} params.to_date - End date (YYYY-MM-DD)
 * @param {string} params.search - Search term (name, email, booking no)
 * @param {number} params.page - Page number
 * @param {number} params.per_page - Items per page
 */
export const getBookingStats = async (params = {}) => {
    try {
        const queryParams = new URLSearchParams();
        
        if (params.from_date) queryParams.append('from_date', params.from_date);
        if (params.to_date) queryParams.append('to_date', params.to_date);
        if (params.search) queryParams.append('search', params.search);
        if (params.page) queryParams.append('page', params.page);
        if (params.per_page) queryParams.append('per_page', params.per_page);
        
        const url = `/api/stats/bookings${queryParams.toString() ? `?${queryParams}` : ''}`;
        const response = await API.get(url);
        
        return response.data;
    } catch (error) {
        console.error('Error in getBookingStats:', error);
        return {
            status: false,
            message: error.response?.data?.message || error.message,
            data: {
                bookings: [],
                stats: {},
                monthly_stats: [],
                pagination: {}
            }
        };
    }
};

/**
 * Get single booking details by ID
 * @param {number} bookingId - Booking ID
 */
export const getBookingDetails = async (bookingId) => {
  try {
    const response = await API.get(`/api/stats/bookings/${bookingId}`);
    console.log('📡 Booking details response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching booking details:', error);
    throw error;
  }
};
/**
 * Get bookings for a specific client (for admin dropdown)
 * @param {number} clientId - Client ID
 */
export const getClientBookings = async (clientId) => {
    try {
        const response = await API.get(`/api/stats/clients/${clientId}/bookings`);
        return response.data;
    } catch (error) {
        console.error('Error in getClientBookings:', error);
        return {
            status: false,
            message: error.response?.data?.message || error.message,
            data: []
        };
    }
};

/**
 * Export bookings to Excel
 * @param {Object} filters - Filter parameters
 */
export const exportBookingsToExcel = async (filters = {}) => {
    try {
        const queryParams = new URLSearchParams();
        
        if (filters.from_date) queryParams.append('from_date', filters.from_date);
        if (filters.to_date) queryParams.append('to_date', filters.to_date);
        if (filters.search) queryParams.append('search', filters.search);
        
        const url = `/api/stats/bookings/export${queryParams.toString() ? `?${queryParams}` : ''}`;
        const response = await API.get(url, {
            responseType: 'blob'
        });
        
        // Create download link
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', `bookings_${new Date().toISOString().slice(0, 19)}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
        
        return { status: true };
    } catch (error) {
        console.error('Error in exportBookingsToExcel:', error);
        return {
            status: false,
            message: error.response?.data?.message || error.message
        };
    }
};


// api/stats.service.js - Add this function
export const getQuotationHistory = async (id) => {
  try {
    const response = await API.get(`/api/bookings/${id}/history`);
    return response.data;
  } catch (err) {
    console.error('Error fetching quotation history:', err);
    throw err;
  }
};

/**
 * Get summary dashboard stats (for home page)
 */
export const getDashboardStats = async () => {
    try {
        const response = await API.get('/api/stats/dashboard');
        return response.data;
    } catch (error) {
        console.error('Error in getDashboardStats:', error);
        return {
            status: false,
            message: error.response?.data?.message || error.message,
            data: {
                total_bookings: 0,
                total_revenue: 0,
                total_commission: 0,
                recent_bookings: [],
                monthly_trend: []
            }
        };
    }
};
